import { render, staticRenderFns } from "./IntroVideo.vue?vue&type=template&id=146e46fd"
import script from "./IntroVideo.vue?vue&type=script&lang=js"
export * from "./IntroVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('146e46fd')) {
      api.createRecord('146e46fd', component.options)
    } else {
      api.reload('146e46fd', component.options)
    }
    module.hot.accept("./IntroVideo.vue?vue&type=template&id=146e46fd", function () {
      api.rerender('146e46fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/views/IntroVideo.vue"
export default component.exports